import React from "react";
import PropTypes from "prop-types";
import ResumoDesktop from "./ResumoDesktop";

function Resumo({ app, config }) {
  return <ResumoDesktop app={app} config={config} />;
}

Resumo.defaultProps = {
  app: null,
  config: {},
};

Resumo.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Resumo;
